import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';

import { TextInputWidth } from '../shared';

export const TextInputWrapper = styled('div')<{
  width: TextInputWidth;
  error: boolean;
  borderColor: string;
}>`
  padding: 0px;
  width: ${({ width }) => width}%;
  min-height: ${pxToRem(65)};
  border: 1px solid
    ${({ theme, error, borderColor }) =>
      error ? theme.color.textInputInvalid : borderColor};
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  margin-bottom: ${({ error }) => (error ? '8px' : '16px')};
  transition: border 0.3s, margin-bottom 0.3s;
`;

export const InputLabel = styled('label')<{ floatLabel: boolean }>`
  position: absolute;
  transition: margin-top 0.3s, font-size 0.3s, margin-left 0.3s, padding 0.3s;
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  font-weight: 500;
  font-size: ${({ floatLabel }) => (floatLabel ? '.8em' : '1em')};
  padding: ${({ floatLabel }) =>
    floatLabel ? '0 4px 0 4px' : `${pxToRem(22)} 0 0 ${pxToRem(16)}`};
  ${({ floatLabel }) =>
    floatLabel
      ? `
      margin-top: -8px;
      margin-left: 16px;
      background-color: #fff;
    `
      : ''}
`;

export const Input = styled('input', {
  shouldForwardProp: (prop) => prop !== 'floatLabel'
})<{ floatLabel: boolean }>`
  outline: none;
  border: 0;
  width: 100%;
  padding: ${pxToRem(22)} ${pxToRem(16)};
  transition: border 0.2s, box-shadow 0.2s;
  font-size: 1em;
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  background: none;

  &::placeholder {
    opacity: ${({ floatLabel }) => (floatLabel ? 1 : 0)};
  }

  // Number
  &::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  // Date
  &[type='date']:invalid::-webkit-datetime-edit {
    color: ${({ theme }) => theme.color.inputLabelText};
  }
`;

export const ErrorMessage = styled('div')<{ visible: boolean }>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.textInputInvalid};
  max-height: ${({ visible }) => (visible ? '24px' : '0')};
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  margin-bottom: ${({ visible }) => (visible ? '16px' : '0')};
  -webkit-transition: max-height 0.3s, opacity 0.3s, padding 0.3s,
    margin-bottom 0.3s;
  -moz-transition: max-height 0.3s, opacity 0.3s, padding 0.3s,
    margin-bottom 0.3s;
  -ms-transition: max-height 0.3s, opacity 0.3s, padding 0.3s,
    margin-bottom 0.3s;
  -o-transition: max-height 0.3s, opacity 0.3s, padding 0.3s, margin-bottom 0.3s;
  transition: max-height 0.3s, opacity 0.3s, padding 0.3s, margin-bottom 0.3s;
  overflow: hidden;
`;

export const IconWrapper = styled('div')`
  margin-left: 16px;
  margin-right: 8px;
  height: 100%;
  display: flex;
`;
